import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 'calc(100vw - 8rem)',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem)'
    },

    '& .table-root': {
      // @ts-expect-error Should exist
      minHeight: ({ loaded }) => (loaded ? 'unset' : '10rem')
    },

    '& .bottomRow': {
      '& .children': {
        width: '100%'
      }
    }
  },

  expand: {
    top: '50%',
    color: 'grey',
    right: '2.5rem',
    cursor: 'pointer',
    display: 'flex',
    position: 'absolute',
    fontSize: theme.size.base,
    transform: 'translateY(-50%)',
    alignItems: 'center',

    '& svg': {
      width: '1rem',
      height: '1rem'
    }
  },

  bottomRow: {
    '& .children': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      gridTemplateRows: 'repeat(2, 25px)',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',

      '& > :nth-child(3)': {
        flexBasis: '100%',
        margin: '0'
      },

      '& label': {
        marginLeft: '0.75rem'
      }
    }
  },

  customSearchRow: {
    display: 'flex',
    alignItems: 'center'
  },

  filtersArea: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: '100%'
  },

  clearIcon: {
    cursor: 'pointer',
    marginLeft: '0.5rem'
  },

  saveIcon: {
    marginLeft: '0.5rem',
    marginRight: 'calc(-1.125rem + 0.5rem)',
    cursor: 'pointer'
  }
}))

export default useStyles
